import React from 'react';
import { Flex } from '@chakra-ui/react';
import { BoxesImage } from './images/BoxesImage';
import { LogoImage } from './images/LogoImage';
import { OrderFormButton } from './OrderFormButton';

export const Header = React.memo(() => {
  return (
    <Flex justifyContent="space-between" alignItems="flex-start">
      <BoxesImage />
      <Flex flexDirection="column" alignItems="center">
        <LogoImage />
        <OrderFormButton />
      </Flex>
    </Flex>
  );
});
